/**
 * QuickFormModal Class
 * Quick Form 모달 열기/닫기 처리
 */
export class QuickFormModal {
    constructor() {
        this.modal = null;
        this.openBtns = [];
        this.closeBtn = null;
        this.overlay = null;
        this.isInitialized = false;
        this.originalDisplay = null; // 원래 display 값 저장
    }

    init() {
        if (this.isInitialized) return;
        
        this.modal = document.getElementById('quickFormModal');
        if (!this.modal) return;

        // 원래 display 값 저장 (인라인 스타일을 임시로 제거하고 CSS 기본값 가져오기)
        const tempDisplay = this.modal.style.display;
        this.modal.style.display = '';
        const computedStyle = window.getComputedStyle(this.modal);
        this.originalDisplay = computedStyle.display || 'flex';
        // 인라인 스타일 복원 (없으면 none으로 설정)
        this.modal.style.display = tempDisplay || 'none';

        this.openBtns = Array.from(document.querySelectorAll('[data-quick-form-modal]'));
        this.closeBtn = this.modal.querySelector('.no-quick-form-modal__close');
        this.overlay = this.modal.querySelector('.no-quick-form-modal__overlay');

        this.bindEvents();
        this.isInitialized = true;
    }

    bindEvents() {
        // 열기 버튼들
        this.openBtns.forEach(btn => {
            btn.addEventListener('click', () => this.open());
        });

        // 닫기 버튼
        this.closeBtn?.addEventListener('click', () => this.close());

        // 오버레이 클릭
        this.overlay?.addEventListener('click', () => this.close());

        // ESC 키로 닫기
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal?.classList.contains('is-open')) {
                this.close();
            }
        });
    }

    open() {
        if (!this.modal) return;
        
        // 저장된 원래 display 값 사용 (기본값은 'flex')
        this.modal.style.display = this.originalDisplay || 'flex';
        document.body.style.overflow = 'hidden';
        
        setTimeout(() => {
            this.modal.classList.add('is-open');
        }, 10);
    }

    close() {
        if (!this.modal) return;
        
        this.modal.classList.remove('is-open');
        
        setTimeout(() => {
            // 원래 display 값으로 복원 (기본값은 'none')
            this.modal.style.display = 'none';
            document.body.style.overflow = '';
        }, 300);
    }
}

